export const PROJECT_ENV = {
    'dev': 'web-gaoding-dev',
    'fat': 'web-gaoding-dev',
    // 'fat': 'web-gaoding-fat',
    // 'stage': 'web-gaoding-stage',
    'stage': 'web-gaoding-prod',
    'prod': 'web-gaoding-prod',
};
